// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1t-nCsr5bPdUg7sPW8QYyR","buttons":"V4wejr73BqGmsFqvTDyOt"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UserProfile/components/DeleteAccountModal.mod.css
// module id = 533
// module chunks = 0